/**
 * Labstep
 *
 * @module
 * @desc Modal showing empy state for premium features
 */

import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import { PremiumFeatureEmptyState } from 'labstep-web/core/PremiumFeature/EmptyState';
import type React from 'react';
import type { IPremiumFeatureModalProps } from './types';

export const PremiumFeatureModal: React.FC<
  IPremiumFeatureModalProps
> = ({ premiumFeature, ...rest }) => (
  <ModalDefault
    dataTestId="premium-feature-modal"
    header="Upgrade Now"
    content={
      <PremiumFeatureEmptyState premiumFeature={premiumFeature} />
    }
    {...rest}
  />
);
